import React from "react";

import "./style.scss";

import FunnelShowMoreHeader from "./Headers/ShowMoreHeader";
import FunnelBasicHeader from "./Headers/BasicHeader";

import { Accordion, AccordionItem, AccordionPanel } from "@chakra-ui/react";

const FunnelDashboardAccordion = ({ alwaysActived, header, headerVariation, error, children, className, accordioncfg }) => {
  const headerComponent = () => {
    if (headerVariation === "show-more")
      return <FunnelShowMoreHeader alwaysActived={alwaysActived} />

    return <FunnelBasicHeader header={header} accordioncfg={accordioncfg} />
  }

  return (
    <Accordion 
      {...(accordioncfg?.close_accordion ? { index: -1 } : {})}
      allowToggle={true} className={`funnel-accordion ${error ? "error" : ""} ${className ?? ""}`}>
      <AccordionItem>
        {headerComponent()}

        <AccordionPanel className="accordion-pannel">{children}</AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default FunnelDashboardAccordion;
